// Configurazione API endpoints per WanderBuddy

const API_CONFIG = {
  // Lambda Function URL per waitlist
  WAITLIST_ENDPOINT: process.env.REACT_APP_WAITLIST_URL || 'https://npy7qwakffdpygrsgv5bsh4ksi0zqezn.lambda-url.us-east-1.on.aws/',
  
  // Altri endpoints API se necessari
  MAIN_API: 'https://api.wanderbuddy.com/lambda',
  
  // Headers comuni
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
  }
};

export { API_CONFIG };
